module.exports = __webpack_public_path__ + "static/media/12.650b906f.jpg";